
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termos-paciente",
      function () {
        return require("private-next-pages/termos-paciente.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termos-paciente"])
      });
    }
  